module.exports = __webpack_public_path__ + "img/Confectioning.00504de7.svg";